import React, { useState } from 'react';
import { login } from '../api';

interface Props {
  onLogin: (user: { email: string; name: string }, token: string) => void;
}

export default function LoginPage({ onLogin }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(email, password);
      onLogin(res.data.user, res.data.token);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.logoRow}>
          <div style={s.logoMark}>PS</div>
          <div>
            <div style={s.logoTitle}>Push App</div>
            <div style={s.logoSub}>Performing Systems</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>E-Mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@performing-systems.de"
              required
              style={s.input}
              onFocus={(e) => (e.target.style.borderColor = '#1a3a5c')}
              onBlur={(e) => (e.target.style.borderColor = '#d2d2d7')}
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={s.input}
              onFocus={(e) => (e.target.style.borderColor = '#1a3a5c')}
              onBlur={(e) => (e.target.style.borderColor = '#d2d2d7')}
            />
          </div>

          {error && <div style={s.error}>{error}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{ ...s.button, opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? 'Anmelden…' : 'Anmelden'}
          </button>
        </form>

        <p style={s.hint}>Internes Tool · Nur für Mitarbeiter</p>
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  wrapper: {
    minHeight: '100vh',
    background: '#f5f5f7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    background: '#ffffff',
    borderRadius: 20,
    padding: '48px 44px 36px',
    width: 400,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06), 0 16px 48px rgba(0,0,0,0.08)',
    animation: 'fadeIn 0.3s ease',
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    marginBottom: 40,
  },
  logoMark: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: '#1a3a5c',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 15,
    letterSpacing: '0.5px',
    flexShrink: 0,
  },
  logoTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#1d1d1f',
    letterSpacing: '-0.3px',
  },
  logoSub: {
    fontSize: 12,
    color: '#6e6e73',
    marginTop: 1,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  label: {
    fontSize: 13,
    fontWeight: 500,
    color: '#1d1d1f',
  },
  input: {
    background: '#f5f5f7',
    border: '1.5px solid #d2d2d7',
    borderRadius: 10,
    padding: '11px 14px',
    color: '#1d1d1f',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  error: {
    background: '#fff2f2',
    border: '1px solid rgba(255,59,48,0.25)',
    borderRadius: 10,
    padding: '10px 14px',
    color: '#ff3b30',
    fontSize: 13,
  },
  button: {
    background: '#1a3a5c',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '13px',
    fontWeight: 600,
    fontSize: 15,
    marginTop: 6,
    letterSpacing: '-0.1px',
  },
  hint: {
    textAlign: 'center' as const,
    marginTop: 24,
    fontSize: 12,
    color: '#aeaeb2',
  },
};
